module.exports = __webpack_public_path__ + "static/media/how-it-works-undercarriage-2.8fbcef87.png";